import React, { useEffect } from 'react'
import './BlockedJourney.css';
import { blockedJourneyImg } from "../../../images/images";
import LanguageTranslater from '../../HOC/LanguageTranslater';
import { getPosvUrl } from '../../../utils/getDevice';
import { isNewUI } from '../../../utils/handleProgress';
import BlockedJourneyNew from '../../POSV_New_Ui/BlockedJourneyNew/BlockedJourneyNew';

function BlockedJourney({ translate }) {
    const ln = localStorage.getItem("LanguageSelected")
    const channelName = localStorage.getItem("channelName")
    const msgType = channelName == 'by' ? 'ybl_blocked_journey' : 'incorrect_res_msg'
    useEffect(() => {
        // window.history.pushState(null, document.title, window.location.href);
        // window.addEventListener('popstate', function () {
        //     window.history.pushState(null, document.title, window.location.href);
        // });

        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function (event) {
            window.history.go(1);
        };
    }, [])

    const handleClick = () => {
        let txnId = sessionStorage.getItem('txnId') ? sessionStorage.getItem('txnId') : undefined
        let url = getPosvUrl(txnId);
        // console.log('url',url);
        window.open(url, '_self')
        // window.open(`http://localhost:3000/vu?id=${txnId}`, '_self')

    }
    return (
        <>
            {isNewUI() ? <BlockedJourneyNew handleClick={handleClick} />
                : <div className="verify_user">
                    <div>
                        <div className="block_journey_container">
                            <img src={blockedJourneyImg} alt="NegativeResponsePopUp" />
                            <h3 className={ln == "Manipuri" ? "manipuri-font" : ""}>{translate('incorrect_res_text')}</h3>
                            <p className={ln == "Manipuri" ? "manipuri-font" : ""}>{translate(msgType)}</p>
                            <span className="block-btn-section">
                                <button className={`block-btn ${ln == "Manipuri" ? "manipuri-font" : ""}`} onClick={handleClick}>{translate('start_verification_again')}</button>
                            </span>
                        </div>

                    </div>
                </div>}
        </>
    )
}

export default LanguageTranslater(BlockedJourney);

